module.exports = __webpack_public_path__ + "img/sad.bf133a20.png";